import { z } from 'zod';

export enum PassFailWithNull {
    Pass = 'Pass',
    Fail = 'Fail',
    Null = '',
}

export const baseSocFormSchema = z.object({
    timingSec: z.number().min(0).nullable().optional(),
    result: z.nativeEnum(PassFailWithNull).nullable().optional(),
    date: z.date(),
});

export const createSocFormSchema = baseSocFormSchema.extend({
    userId: z.string().nonempty({ message: 'Trainee is required' }),
    assessmentRunId: z.string().nonempty(),
});

export type CreateSocFormData = z.infer<typeof createSocFormSchema>;

export type EditSocFormData = z.infer<typeof baseSocFormSchema> & {
    timingSecMinutes?: number | null;
    timingSecSeconds?: number | null;
};

export const socDefaultFormValues: CreateSocFormData = {
    timingSec: null,
    result: null,
    date: new Date(),
    assessmentRunId: '',
    userId: '',
};
